module.exports = __webpack_public_path__ + "static/nice-house-7358fcfcc7bf8566b54cf38b5fbdd81b.jpg";